import type {
  BookingWorkOrderFullPdfApiData,
  BookingWorkOrderFullPdfApiResponses,
  BookingWorkOrderGetApiData,
  BookingWorkOrderGetApiResponses,
  BookingWorkOrderMiniPdfApiData,
  BookingWorkOrderMiniPdfApiResponses,
  DepartmentWorkOrdersDayListApiData,
  DepartmentWorkOrdersDayListApiResponses
} from '@navio/nsdk';

import { getFilenameFromContentDisposition } from '../../browserBlobDownload';
import { apiUrl, dataEndpoint } from '../defineResource';

export const workOrderUrls = {
  getBookingWorkOrder: dataEndpoint<BookingWorkOrderGetApiData, BookingWorkOrderGetApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/work-order/`)
  }),
  downloadBookingWorkOrderFullPdf: dataEndpoint<BookingWorkOrderFullPdfApiData, BookingWorkOrderFullPdfApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/work-order/pdf/`),
    responseType: 'blob',
    sideEffectGet: true,
    handleRes: async (res) => {
      const blob = res.data;
      const filename = getFilenameFromContentDisposition(res.headers['content-disposition'], 'work-order.pdf');
      // File (not auto-download) so UI can preview / print / download.
      return new File([blob], filename, { type: blob.type || 'application/pdf' });
    }
  }),
  downloadBookingWorkOrderMiniPdf: dataEndpoint<BookingWorkOrderMiniPdfApiData, BookingWorkOrderMiniPdfApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/work-order/mini/pdf/`),
    responseType: 'blob',
    sideEffectGet: true,
    handleRes: async (res) => {
      const blob = res.data;
      const filename = getFilenameFromContentDisposition(res.headers['content-disposition'], 'work-order-mini.pdf');
      // File (not auto-download) so UI can preview / print / download.
      return new File([blob], filename, { type: blob.type || 'application/pdf' });
    }
  }),
  getDepartmentWorkOrdersDayList: dataEndpoint<
    DepartmentWorkOrdersDayListApiData,
    DepartmentWorkOrdersDayListApiResponses
  >({
    getUrl: ({ serviceDepartmentId, ...queryParams }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/work-orders/`, queryParams)
  })
};
